import gql from 'graphql-tag';
import { clients } from '../../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../../util/shared/vue-global';
// import { taxPayment } from '../../payments.js';

const { backend } = clients.direct;

const taxFileds = {
  _id: '',
  taxYear: '',
  taxId: '',
  schoolDistrict: '',
  taxAmt: '',
  penaltyAmt: '',
  taxType: '',
  itsNewRecord: '',
  fees: {
    feeDescription: '',
    feeMongoId: '',
    feeAmount: '',
  },
  total: '',
  void: '',
  protest: '',
  posted: '',
  reciept: '',
  totalFees: '',
};
const taxExemptField = {
  // _id: '',
  taxYear: '',
  taxId: '',
  totalTax: '',
  totalPaid: '',
  totalDue: '',
  ownerName: '',
  taxInquiryTransaction: '',
  taxPayments: {
    _id: '',
    taxDetails: {
      ...taxFileds,
    },
    fiscalYear: '',
    payDate: '',
    paymentNumber: '',
    workstation: '',
    overUnderStatus: '',
    misMatchFlag: '',
    loadMoreTax: '',
    paymentDetails: {
      _id: '',
      checkNumber: '',
      paymentType: '',
      eftType: '',
      creditType: '',
      amount: '',
      paidBy: '',
      isReconcilled: '',
    },
  },
};

const taxExemptPaymentField = {
  isExempt: '',
  totalTaxAmt: '',
  payDate: '',
};
const taxExemptMfgField = {
  apportionmentData: {
    _id: '',
    priority: '',
    recordType: '',
    fundNumber: '',
    taxYear: '',
    taxDistrict: '',
    payDate: '',
    baseAmount: '',
    expectedAmount: '',
    apportionmentAmount: '',
    collectedAmount: '',
    unCollectedAmount: '',
    taxUnit: '',
    taxFundDescription: '',
    apportionmentDetails: {
      priority: '',
      recordType: '',
      fundNumber: '',
      taxYear: '',
      taxDistrict: '',
      payDate: '',
      baseAmount: '',
      expectedAmount: '',
      apportionmentAmount: '',
      collectedAmount: '',
      unCollectedAmount: '',
      taxUnit: '',
      taxFundDescription: '',

    },
  },
};

const apportionmentSummaryDataField = {
  priority: '',
  totalExpectedAmount: '',
  totalApportionmentAmount: '',
  totalCollectedAmount: '',
  totalUnCollectedAmount: '',
};

const texExemptUpsertField = {
  _id: '',
  priority: '',
  recordType: '',
  fundNumber: '',
  taxYear: '',
  taxDistrict: '',
  payDate: '',
  baseAmount: '',
  expectedAmount: '',
  apportionmentAmount: '',
  collectedAmount: '',
  unCollectedAmount: '',
  taxUnit: '',
  taxFundDescription: '',
};

export const taxExemptMfg = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    selectedItems: [],

  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },

  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },

  },
  actions: {
    async loadExemptTax({ dispatch, commit }, { criteria, baseCrudKey }) {
      let results;

      try {
        await dispatch('reAuth', null, { root: true });

        results = await backend.query({
          query: gql`query loadExemptTax ($criteria:taxExemptCriteriaType) {
            loadExemptTax (criteria: $criteria){
              ${(fieldsToGqlString(taxExemptField))}
            }
          }`,
          variables: {
            criteria,
          },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        const data = results.data.loadExemptTax;
        commit('base/crud/setItems', [baseCrudKey, data || []], { root: true });
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while upserting the Exempt Tax transaction!', { root: true });
      }
    },
    async updateExemptFromTaxInquiry({ dispatch, commit }, { criteria, baseCrudKey }) {
      let results;

      try {
        await dispatch('reAuth', null, { root: true });

        results = await backend.query({
          query: gql`query updateExemptFromTaxInquiry ($criteria:taxExemptCriteriaType) {
            updateExemptFromTaxInquiry (criteria: $criteria){
              ${(fieldsToGqlString(taxExemptField))}
            }
          }`,
          variables: {
            criteria,
          },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        const data = results.data.updateExemptFromTaxInquiry;
        commit('base/crud/setItems', [baseCrudKey, data || []], { root: true });
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while upserting the Exempt Tax transaction!', { root: true });
      }
    },
    async loadExemptTaxPayment({ dispatch, commit }, { criteria, baseCrudKey }) {
      let results;

      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query loadExemptTaxPayment ($criteria:taxExemptPaymentCriteriaType) {
            loadExemptTaxPayment (criteria: $criteria){
              ${(fieldsToGqlString(taxExemptPaymentField))}
            }
          }`,
          variables: {
            criteria,
          },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        const data = results.data.loadExemptTaxPayment;
        commit('base/crud/setItems', [baseCrudKey, data || []], { root: true });
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while upserting the Exempt Tax payment transaction!', { root: true });
      }
    },

    async createExemptMfgApportion({ dispatch, commit }, { criteria, baseCrudKey }) {
      let results;

      try {
        await dispatch('reAuth', null, { root: true });

        results = await backend.query({
          query: gql`query createExemptMfgApportion($criteria:taxExemptApportionmentCriteriaType) {
            createExemptMfgApportion(criteria: $criteria) {
              ${(fieldsToGqlString({ ...taxExemptMfgField, apportionmentSummaryData: apportionmentSummaryDataField }))}
            }
          }`,
          variables: {
            criteria,
          },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);

        // eslint-disable-next-line max-len
        const { apportionmentData, apportionmentSummaryData } = results.data.createExemptMfgApportion;

        commit('base/crud/setItems', [baseCrudKey, apportionmentData || []], { root: true });
        commit('base/crud/setItems', ['exemptMfgSummaryKey',
          apportionmentSummaryData || []], { root: true });
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while upserting the Exempt Tax transaction!', { root: true });
      }
    },
    async loadExemptMfgApportion({ dispatch, commit }, { criteria, baseCrudKey }) {
      let results;

      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query loadExemptMfgApportion($criteria:taxExemptApportionmentCriteriaType) {
            loadExemptMfgApportion(criteria: $criteria) {
              ${(fieldsToGqlString(taxExemptMfgField))}
            }
          }`,
          variables: {
            criteria,
          },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        const {
          apportionmentData,
        } = results.data.loadExemptMfgApportion;
        // const result = [];

        // Loop through each record
        // apportionmentData.forEach((record, i) => {
        // Add the "Original" record to the result
        // if (result.find((el) => el?._id !== record?._id) || i === 0) {
        //   result.push(record);
        // }

        // If there are any "Details" in apportionmentDetails, append them right after
        // if (record?.apportionmentDetails && record?.apportionmentDetails.length > 0) {
        //   record.apportionmentDetails.forEach((detail) => {
        //     result.push(detail); // Add each detail to the result
        //   });
        // }
        // });

        commit('base/crud/setItems', [baseCrudKey, apportionmentData || []], { root: true });
        // commit('base/crud/setItems', ['exemptMfgSummaryKey',
        //   apportionmentSummaryData || []], { root: true });
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while loading the  transaction!', { root: true });
      }
    },
    async loadExemptMfgApportionSummary({ dispatch, commit }, { criteria }) {
      let results;

      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query loadExemptMfgApportionSummary($criteria:taxExemptApportionmentCriteriaType) {
            loadExemptMfgApportionSummary(criteria: $criteria) {
              ${(fieldsToGqlString(apportionmentSummaryDataField))}
            }
          }`,
          variables: {
            criteria,
          },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        const apportionmentSummaryData = results.data.loadExemptMfgApportionSummary;
        // const result = [];

        // Loop through each record
        // apportionmentData.forEach((record, i) => {
        // Add the "Original" record to the result
        // if (result.find((el) => el?._id !== record?._id) || i === 0) {
        //   result.push(record);
        // }

        // If there are any "Details" in apportionmentDetails, append them right after
        // if (record?.apportionmentDetails && record?.apportionmentDetails.length > 0) {
        //   record.apportionmentDetails.forEach((detail) => {
        //     result.push(detail); // Add each detail to the result
        //   });
        // }
        // });

        // commit('base/crud/setItems', [baseCrudKey, apportionmentData || []], { root: true });
        commit('base/crud/setItems', ['exemptMfgSummaryKey',
          apportionmentSummaryData || []], { root: true });
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while loading the  transaction!', { root: true });
      }
    },
    async upsertTaxExempt({ dispatch, rootGetters, commit }, { item, baseCrudKey }) {
      let results;

      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertTaxExempt($item:taxExemptApportionmentInputType) {
            upsertTaxExempt(upsert:$item) {
              ${(fieldsToGqlString(texExemptUpsertField))}
            }
          }`,
          variables: {
            item,
          },
        });

        clients.handleGQLErrors(results, commit);
        const data = rootGetters['base/crud/items'](baseCrudKey);
        const newData = results.data.upsertTaxExempt;
        const newList = mergeByIdNewAtTop(data || [], newData);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while upserting the  Exempt Tax transaction!', { root: true });
      }
    },
    // createTifExemptMfgApportion
    async createTifExemptMfgApportion({ dispatch, commit }, { item }) {
      let results;

      const queryFields = {
        statusCode: '',
      };
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation createTifExemptMfgApportion($item:tifBaseDistrictsInputType) {
            createTifExemptMfgApportion(upsert:$item) {
              ${(fieldsToGqlString(queryFields))}
            }
          }`,
          variables: {
            item,
          },
        });

        clients.handleGQLErrors(results, commit);
        return results.data.createTifExemptMfgApportion;
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while upserting the tif base district in exempt mfg!', { root: true });
      }
      return {};
    },
    async upsertTifBaseDistricts({ dispatch, commit }, { item }) {
      let results;

      const queryFields = {
        statusCode: '',
      };
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertTifBaseDistricts($item:tifBaseDistrictsInputType) {
            upsertTifBaseDistricts(upsert:$item) {
              ${(fieldsToGqlString(queryFields))}
            }
          }`,
          variables: {
            item,
          },
        });

        clients.handleGQLErrors(results, commit);
        return results.data.upsertTifBaseDistricts;
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while upserting the tif base district in exempt mfg!', { root: true });
      }
      return {};
    },
    async exemptTaxesTotal({ commit, dispatch }, {
      criteria,
    }) {
      let results;
      try {
        const gqlfields = {
          totalTax: '',
          totalPaid: '',
          totalDue: '',
        };
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
                query getExemptTaxesTotal($criteria: exemptTaxesCriteriaType) {
                  getExemptTaxesTotal(criteria: $criteria) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }
              `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        return results.data.getExemptTaxesTotal || [];
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting exempt total.', { root: true });
        return [];
      }
    },
    async getExemptApportionmentTotal({ commit, dispatch }, {
      criteria,
    }) {
      let results;
      try {
        const gqlfields = {
          expectedAmount: '',
          apportionmentAmount: '',
          collectedAmount: '',
          unCollectedAmount: '',
        };
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
                query getExemptApportionmentTotal($criteria: taxExemptApportionmentCriteriaType) {
                  getExemptApportionmentTotal(criteria: $criteria) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }
              `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        return results.data.getExemptApportionmentTotal || [];
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting exempt total.', { root: true });
        return [];
      }
    },
    async hasOriginalExemptApportionment({ dispatch, commit }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query hasOriginalExemptApportionment($criteria:taxExemptApportionmentCriteriaType) {
            hasOriginalExemptApportionment(criteria: $criteria)
          }`,
          variables: {
            criteria,
          },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        return !!(results.data && results.data.hasOriginalExemptApportionment);
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem checking for exempt apportionment records.', { root: true });
        return false;
      }
    },
    async getExemptBasedOnTif({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        const queryFields = {
          schoolDistrict: '',
          tifSchoolDistrict: '',
          totalTaxSum: '',
          taxAmountInBase: '',
        };
        results = await backend.query({
          query: gql`query getExemptBasedOnTif ($criteria:taxExemptCriteriaType) {
            getExemptBasedOnTif (criteria: $criteria){
              ${(fieldsToGqlString(queryFields))}
            }
          }`,
          variables: {
            criteria,
          },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        return results.data.getExemptBasedOnTif || [];
      } catch (e) {
        dispatch('logException', e, { root: true });
        dispatch('flashError', 'There was a problem getting exempt based on TIF.', { root: true });
        return [];
      }
    },
  },
};

export default taxExemptMfg;
